<template>
    <input type="text" @keyup="change" @change="change">
</template>

<script>
    export default {
        name: "PhoneMaskComponent",
        data() {
            return {
                phoneField: ''
            }
        },
        props: {
            countries: {
                type: Array
            },
            modelValue: {
                default: null
            }
        },
        methods: {
            init() {
                let self = this;
                let countries = this.countries ? this.countries : this.getDefaultCountries();

                this.phoneField = jQuery(this.$el);

                this.phoneField.intlTelInput({
                    autoPlaceholder: 'off',
                    nationalMode: true,
                    utilsScript: '/js/utils.js',
                    preferredCountries: [],
                    separateDialCode: true,
                    onlyCountries: countries
                });

                if (this.modelValue) {
                    this.phoneField.intlTelInput('setNumber', this.modelValue);
                }

                this.phoneField.on("countrychange", function(e, countryData) {
                    self.change();
                });
            },

            getDefaultCountries() {
                return ['be', 'nl', 'de', 'lu', 'fr', 'gb']
            },

            change()
            {
                this.$emit('update:modelValue', this.phoneField.intlTelInput("getNumber"));
            }
        },
        mounted: function() {
            this.init();
        },
        watch: {
            modelValue(value) {
                const self = this;

                if (value !== null) {
                    self.phoneField.intlTelInput('setNumber', self.modelValue);
                }
            }
        }
    }
</script>